import Client from './modules/ClientApi'

import Employee from './modules/EmployeeApi'

import Company from './modules/CompanyApi'

import User from './modules/UserApi'

import Project from './modules/ProjectApi'
import Stage from './modules/StageApi'
import Task from './modules/TaskApi'

import Agenda from './modules/AgendaApi'

import Movement from './modules/MovementApi'

import Document from './modules/DocumentApi'
import DocLabel from './modules/DocLabelApi'
import CompanyTags from './modules/CompanyTagsApi'

import Role from './modules/RoleApi'

export default {
  User,
  Company,
  Employee,

  Client,

  Project,
  Stage,
  Task,

  Agenda,

  Movement,

  Document,
  DocLabel,

  CompanyTags,

  Role,
}
